var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"guests-wrapper"},[_vm._l((_vm.iconsCount),function(i){return _c('icon',{key:i,attrs:{"width":"11","height":"12","type":"user","path":"avatars"}})}),(_vm.moreIcons)?[_vm._v(" × "+_vm._s(_vm.g)+" ")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }